/* ============================================================
   Textil World — Accessibility v2 JS (2026-08-20, v7)
   Runtime a11y + UX fixes.
   v6: for the min-qty notice, PHYSICALLY move the element out of the
   qty/cart row and append it as a sibling below the form, so no flex
   ordering tricks are needed.
   v7: scope the min-qty scan to product templates and skip <script> text —
   the document.body fallback was matching the minimum-quantity app's settings
   JSON and printing ~2.6 kB of it at the bottom of every non-product page.
   ============================================================ */
(function () {
  'use strict';

  var MIN_QTY_RE = /Minimalna\s+ilość\s+dla\s+tego\s+produktu/i;

  function syncInert(el) {
    var hidden = el.getAttribute('aria-hidden') === 'true';
    try { el.inert = hidden; } catch (e) { }
  }
  var ariaObserver = new MutationObserver(function (muts) {
    muts.forEach(function (m) { if (m.attributeName === 'aria-hidden') syncInert(m.target); });
  });
  function trackAriaHidden(el) {
    syncInert(el);
    ariaObserver.observe(el, { attributes: true, attributeFilter: ['aria-hidden'] });
  }
  document.querySelectorAll('[aria-hidden]').forEach(trackAriaHidden);

  function fixListSemantics() {
    document.querySelectorAll('ul.t4s-flickity-slider, ul.t4s-tabs-ul, ul.t4s-tabs-ul2').forEach(function (ul) {
      if (ul.getAttribute('role') !== 'presentation') ul.setAttribute('role', 'presentation');
    });
    document.querySelectorAll('li.t4s-tab-item, li.t4s-col-item, li.t4s-slide').forEach(function (li) {
      if (li.getAttribute('role') !== 'presentation') li.setAttribute('role', 'presentation');
    });
  }
  fixListSemantics();

  function fixStyleRoles() {
    document.querySelectorAll('style[role]').forEach(function (s) { s.removeAttribute('role'); });
  }
  fixStyleRoles();

  function fixDecorativeImages() {
    document.querySelectorAll('video.t4s_bg_vid_html5').forEach(function (vid) {
      var imgs = vid.parentElement ? vid.parentElement.querySelectorAll('img:not([alt])') : [];
      imgs.forEach(function (img) {
        img.setAttribute('alt', '');
        img.setAttribute('aria-hidden', 'true');
      });
    });
    document.querySelectorAll('img:not([alt])').forEach(function (img) { img.setAttribute('alt', ''); });
  }
  fixDecorativeImages();

  function fixVideoCaptions() {
    document.querySelectorAll('video').forEach(function (vid) {
      if (vid.querySelector('track[kind="captions"]')) return;
      var track = document.createElement('track');
      track.kind = 'captions';
      track.srclang = 'pl';
      track.label = 'Brak dźwięku (dekoracyjne)';
      track.src = 'data:text/vtt;base64,V0VCVlRUCgo=';
      track['default'] = true;
      vid.appendChild(track);
    });
  }
  fixVideoCaptions();

  /* Min-qty notice — create our OWN clean chip and hide the original.
     The notice only ever exists inside a product form, so we must NOT fall back to
     document.body on other templates: the minimum-quantity app ships its Polish
     message inside <script id="wm-settings" type="application/json">, a TreeWalker
     descends into script text, and matching there printed the whole settings blob
     into the page. Three independent guards below: template, node type, length. */
  function fixMinQtyNotice() {
    var scope = document.querySelector('.t4s-product-form__variants')
      || (document.body.classList.contains('template-product') ? document.body : null);
    if (!scope) return;
    // Locate the notice text once per scope
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!MIN_QTY_RE.test(n.nodeValue || '')) return NodeFilter.FILTER_REJECT;
        var tag = n.parentElement ? n.parentElement.nodeName : '';
        if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'TEMPLATE' || tag === 'NOSCRIPT') {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var textNode = walker.nextNode();
    if (!textNode) return;

    // Find the smallest ancestor element that wraps just this notice (nothing else useful)
    var host = textNode.parentElement;
    // If our clean copy already exists, don't re-run
    if (scope.querySelector('.tw-min-qty-clean')) return;

    // Hide the original wrapper (walk up to the first block-ish container that only holds this text)
    var native = host;
    var safety = 0;
    while (native && native !== scope && safety++ < 6) {
      var txt = (native.textContent || '').trim();
      if (MIN_QTY_RE.test(txt) && txt.length < 120) {
        // If parent has ONLY this text (or close), climb one more so we hide the whole native pill
        var parent = native.parentElement;
        if (parent && parent !== scope) {
          var pTxt = (parent.textContent || '').trim();
          if (pTxt === txt) { native = parent; continue; }
        }
        break;
      }
      native = native.parentElement;
    }
    var noticeText = (textNode.nodeValue || '').trim();
    // A genuine notice is one short sentence; anything longer is not ours to print.
    if (noticeText.length > 160) return;
    if (native && native !== scope) {
      native.style.setProperty('display', 'none', 'important');
    }

    // Build our own clean line
    var clean = document.createElement('div');
    clean.className = 'tw-min-qty-clean';
    clean.setAttribute('role', 'status');
    clean.textContent = noticeText;

    // Insert AFTER the qty/cart row if we can, else after the form
    var row = scope.querySelector('.t4s-pr__qty_cart') || scope.querySelector('.t4s-product-form__buttons');
    if (row && row.parentNode) {
      if (row.nextSibling) row.parentNode.insertBefore(clean, row.nextSibling);
      else row.parentNode.appendChild(clean);
    } else {
      scope.appendChild(clean);
    }
  }
  fixMinQtyNotice();

  function labelViewAll() {
    var SEL = 'a.t4s-btn, a.t4s-viewall-btn, a.t4s-btn-base';
    document.querySelectorAll(SEL).forEach(function (a) {
      if (a.hasAttribute('aria-label')) return;
      var text = (a.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (!/zobacz wszystkie/.test(text)) return;
      var href = (a.getAttribute('href') || '').toLowerCase();
      var label = 'Zobacz wszystkie';
      if (href.indexOf('zastosowanie') > -1) label = 'Zobacz wszystkie zastosowania';
      else if (href.indexOf('new-collection') > -1 || href.indexOf('nowa') > -1) label = 'Zobacz wszystkie nowości';
      else if (href.indexOf('outlet') > -1) label = 'Zobacz cały outlet';
      else if (href.indexOf('blog') > -1) label = 'Zobacz wszystkie artykuły';
      else if (href.indexOf('bestseller') > -1) label = 'Zobacz wszystkie bestsellery';
      else if (href.indexOf('collection') > -1) label = 'Zobacz wszystkie produkty';
      a.setAttribute('aria-label', label);
    });
  }
  labelViewAll();

  new MutationObserver(function (muts) {
    var needsRescan = false;
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.hasAttribute && n.hasAttribute('aria-hidden')) trackAriaHidden(n);
        if (n.querySelectorAll) n.querySelectorAll('[aria-hidden]').forEach(trackAriaHidden);
        if (n.nodeName === 'STYLE' && n.hasAttribute('role')) n.removeAttribute('role');
        needsRescan = true;
      });
    });
    if (needsRescan) {
      fixListSemantics();
      fixStyleRoles();
      fixDecorativeImages();
      fixVideoCaptions();
      fixMinQtyNotice();
      labelViewAll();
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

})();
